import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { styled } from '@wp-g2/styles';
export var AccordionView = styled.div(_templateObject());